export default __webpack_public_path__ + "9b15278750334633a0c0804c78423189.png";